import * as React from "react";
import {createElement as h} from "react";
import {css, cx} from "emotion";

import "./left-menu-item.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {MenuInternalLink} from "../../../common/components/internal-link";
import {getAbsLink}       from "../../../common/get-abs-link";

export const rLeftMenuItem = ({label, link, type, expanded, rDropdown, onChangeExpanded, navBlock=undefined}) => cs(
    consumeContext("themeScheme"),
    ({themeScheme}) => cs(
        ({}, next) => (
            <div className={cx("item left-menu-item-mobile-4sw", {expanded})} xd-qa-type="link" xd-qa-name={label}>
                {next()}

                {expanded && (
                    <div
                        className={cx("expand")}
                    >
                        <div className="content">
                            {rDropdown()}
                        </div>
                    </div>
                )}
            </div>
        ),
        ({}, next) => (
            type === "internalUrl" && (!rDropdown || expanded) ? (
                MenuInternalLink({
                    to: link,
                    className: cx("toggle"),
                    navBlock,
                    children: next(),
                })
            ) : (
                h(!rDropdown || expanded ? "a" : "div",
                    {
                        className: "toggle",
                        href: getAbsLink(link),
                        onClick: async (e) => {
                            e.preventDefault();
                            if (await navBlock?.block() === true) {
                                return;
                            }
                            if (!rDropdown || expanded) {
                                window.location.href=getAbsLink(link);
                            }
                            onChangeExpanded(true);
                        },
                    },
                    next(),
                )
            )
        ),
        () => (
            <div
                className={cx("text",
                    css`
                        color: ${themeScheme.xpresso.menuTextColor};
                        &:after {
                            background: ${themeScheme.xpresso.menuTextColor};
                        }
                    `
                )}
            >
                {label}
            </div>
        )
    ),
);
